import { Account } from '../../../../models/customer';
import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { SelectedAccountsSettings } from '../selected-accounts-settings';
import { I18N } from 'aurelia-i18n';

@autoinject()
export class CardOffer {
	selectedAccounts: Array<Account> = [];
	selectedAccountsSettings: SelectedAccountsSettings;
	message: string = '';

	constructor(private i18n: I18N, private router: Router) {}

	activate(model) {
		if (!!model) {
			this.selectedAccounts = model.selectedAccounts;
			this.selectedAccountsSettings = model.selectedAccountsSettings;
			this.setMessageText();
		}
	}

	setMessageText() {
		this.message = this.i18n.i18next.t('submitOfferCreateCustomPlan', 'Submit an offer and create your own custom plan');
	}

	makeOffer = () => {
		// assume only one account can be selected
		this.router.navigateToRoute('negotiator', { id: this.selectedAccounts[0].id });
	}
}
